import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { ModalBox } from '../Outer/Modal';
import { AuctionTeamOrder } from './AuctionTeamOrder';
import { useAuctionForm } from './useAuctionForm';
import { FormActions } from './FormActions';
import { ImageFileInput } from './ImageFileInput';
import {
  AuctionNameInput,
  BidTimeSelect,
  ContestSelect,
  ManagerHoldInput,
  SportName,
  StartDatePicker,
  WinnerFields,
} from './AuctionFormFields';

const FORM_ID = 'update-auction-form';

/**
 * The Update Auction modal of the Auctions list (Auction.js), on the form Create Auction uses
 * (useAuctionForm). Starting Bid, Minimum Bid Increment and the secondary market are not edited here.
 *
 * @param {{auction: Object, show: boolean, onClose: () => void, onSaved: () => void}} props auction is
 *   the list row being edited. Give the component a new key for each opening, so the form starts from
 *   the row again rather than from what was typed and cancelled.
 */
export const UpdateAuctionModal = ({ auction, show, onClose, onSaved }) => {
  const form = useAuctionForm({ auction, onSaved });

  return (
    <ModalBox
      show={show}
      onHide={onClose}
      title="Update Auction"
      body={
        <Form id={FORM_ID} noValidate validated={form.values.validated} className="manager-form" onSubmit={form.submit}>
          <Row>
            <Form.Group as={Col} md={6} controlId="validationCustom02">
              <AuctionNameInput form={form} />
            </Form.Group>

            <Form.Group as={Col} md={6} className="text-left">
              <ContestSelect form={form} />
            </Form.Group>

            <SportName form={form} />

            {form.values.tournamentId ? (
              <Col lg={12}>
                <AuctionTeamOrder teams={form.values.teams} onChange={form.reorderTeams} />
              </Col>
            ) : (
              ''
            )}

            <Form.Group as={Col} md={6}>
              <StartDatePicker form={form} labelClassName="mt-3" />
            </Form.Group>

            <Form.Group as={Col} md={6}>
              <BidTimeSelect form={form} />
            </Form.Group>

            <Form.Group as={Col} md={6}>
              <ManagerHoldInput form={form} className="select-option tournament form-control" />
            </Form.Group>

            {/* #308: the page's own picker and the hint every image field shows. */}
            <Form.Group as={Col} md={6} controlId="edit-auction-logo">
              <Form.Label className="mt-3">Logo image</Form.Label>
              <ImageFileInput name="auctionImage" onPick={form.uploadImage} />
            </Form.Group>
            <Form.Group as={Col} md={6}></Form.Group>

            {form.imageUrl && <img src={form.imageUrl} alt="Selected" style={{ width: '100px' }} />}

            <WinnerFields form={form} />
          </Row>
        </Form>
      }
      footer={
        <FormActions
          form={FORM_ID}
          onCancel={onClose}
          submitLabel="Update"
          disabled={form.saving || form.uploading}
          className="mt-0"
        />
      }
    />
  );
};
